/**
 * Header Section (Aqua) - JavaScript
 * Handles mobile menu toggle and sticky header
 */

(function() {
  'use strict';

  class HeaderSection {
    constructor(header) {
      this.header = header;
      this.menuToggle = header.querySelector('[data-menu-toggle]');
      this.menuClose = header.querySelector('[data-menu-close]');
      this.mobileMenu = header.querySelector('[data-mobile-menu]');
      this.overlay = header.querySelector('[data-menu-overlay]');

      this.isMenuOpen = false;

      this.init();
    }

    init() {
      this.bindEvents();
    }

    bindEvents() {
      // Menu toggle button
      if (this.menuToggle) {
        this.menuToggle.addEventListener('click', () => {
          this.openMenu();
        });
      }

      // Menu close button
      if (this.menuClose) {
        this.menuClose.addEventListener('click', () => {
          this.closeMenu();
        });
      }

      // Overlay click
      if (this.overlay) {
        this.overlay.addEventListener('click', () => {
          this.closeMenu();
        });
      }

      // Close menu on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isMenuOpen) {
          this.closeMenu();
        }
      });

      // Close menu when clicking a link
      const mobileLinks = this.header.querySelectorAll('.header-section__mobile-nav-link');
      mobileLinks.forEach(link => {
        link.addEventListener('click', () => {
          this.closeMenu();
        });
      });
    }

    openMenu() {
      this.isMenuOpen = true;
      this.mobileMenu.classList.add('is-open');
      this.overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';

      // Update aria attributes
      this.menuToggle.setAttribute('aria-expanded', 'true');
    }

    closeMenu() {
      this.isMenuOpen = false;
      this.mobileMenu.classList.remove('is-open');
      this.overlay.classList.remove('is-visible');
      document.body.style.overflow = '';

      // Update aria attributes
      this.menuToggle.setAttribute('aria-expanded', 'false');
    }
  }

  // Initialize
  function initHeaderSections() {
    const headers = document.querySelectorAll('.header-section');
    headers.forEach(header => {
      if (!header.dataset.initialized) {
        new HeaderSection(header);
        header.dataset.initialized = 'true';
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderSections);
  } else {
    initHeaderSections();
  }

  // Re-initialize on Shopify section load
  document.addEventListener('shopify:section:load', (event) => {
    const header = event.target.querySelector('.header-section');
    if (header) {
      header.dataset.initialized = '';
      new HeaderSection(header);
      header.dataset.initialized = 'true';
    }
  });
})();
